var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 12
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.408.923a.57.57 0 0 0-.815 0L.655 5.048a.562.562 0 0 0 .813.776l2.97-3.108v7.972a.561.561 0 1 0 1.125 0V2.715l2.967 3.11a.562.562 0 0 0 .813-.775L5.406.926l.002-.003Z"
})));
export default SvgArrowIcon;